import { defineInlineAdSlotSchema } from "~/components/content/content-schema-render/inline-ad-slot/schemas";
import { defineTrackViewedPercentageSchema } from "~/components/content/content-schema-render/track-viewed-percentage/schemas";

export const NumberOfReadableElementInPaywall = 3;

export const DefaultCustomContents = [
  defineInlineAdSlotSchema({ row: 4, tag: "0" }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
    row: 5,
  }),
  defineInlineAdSlotSchema({ row: 7, tag: "1" }),
  { row: 10, type: "inline-widget" },
  defineTrackViewedPercentageSchema({
    percentage: "50",
    row: 11,
  }),
  defineInlineAdSlotSchema({ row: 12, tag: "2" }),
  defineInlineAdSlotSchema({ row: 15, tag: "3" }),
  defineInlineAdSlotSchema({ row: 19, tag: "4" }),
  defineInlineAdSlotSchema({ row: 23, tag: "5" }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
    row: -1,
  }),
  defineInlineAdSlotSchema({ row: -1, tag: "6" }),
];
